import { startNewSession } from './sessions.service';

localStorage.setItem('test', 'test')

const URL = 'https://den-mera.tass.ru';

$(() => {
  localStorage.removeItem('session');
  $(`#start`).click(start);

  initSharing(
    URL,
    'ДЕНЬ МЭРА',
    'Думаешь, легко быть мэром? Попробуй себя в его кресле!',
    `${URL}/src/img/share.png`
  );
});

function start(event) {
  event.stopPropagation();
  event.preventDefault();
  startNewSession('rules.html');
}

function initSharing(url, title, description, image) {
  Ya.share2('sharing', {
    content: {
      url, title, description, image
    },
    theme: {
      services: 'facebook,vkontakte,twitter,odnoklassniki'
    }
  });
}


